import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { ArkikWebComponentsModule, CORE_AUTH_CONFIG, CoreAuthConfig } from 'core';
import { TalkToYourDataRoutingModule } from './talk-to-your-data-routing.module';
import { ChatbotPageContainerComponent } from './features/chatbot-fullscreen/containers/chatbot-page.container';
import { ChatbotShellComponent } from './features/chatbot-fullscreen/components/chatbot-shell.component';
import { SidebarComponent } from './features/chatbot-fullscreen/components/sidebar.component';
import { BrandGroupComponent } from './features/chatbot-fullscreen/components/brand-group.component';
import { NewChatButtonComponent } from './features/chatbot-fullscreen/components/new-chat-button.component';
import { QuickQuestionListComponent } from './features/chatbot-fullscreen/components/quick-question-list.component';
import { ConversationHistoryComponent } from './features/chatbot-fullscreen/components/conversation-history.component';
import { SavedConversationsComponent } from './features/chatbot-fullscreen/components/saved-conversations.component';
import { ConversationListItemComponent } from './features/chatbot-fullscreen/components/conversation-list-item.component';
import { UserProfileComponent } from './features/chatbot-fullscreen/components/user-profile.component';
import { WelcomePanelComponent } from './features/chatbot-fullscreen/components/welcome-panel.component';
import { SuggestionCardComponent } from './features/chatbot-fullscreen/components/suggestion-card.component';
import { ConversationPanelComponent } from './features/chatbot-fullscreen/components/conversation-panel.component';
import { MessageListComponent } from './features/chatbot-fullscreen/components/message-list.component';
import { MessageItemComponent } from './features/chatbot-fullscreen/components/message-item.component';
import { MessageRendererComponent } from './features/chatbot-fullscreen/components/message-renderer.component';
import { MessageInputComponent } from './features/chatbot-fullscreen/components/message-input.component';
import { CollapsibleSectionComponent } from './features/chatbot-fullscreen/components/collapsible-section.component';
import { ChatbotMarkdownPipe } from './shared/pipes/chatbot-markdown.pipe';
import { TimeAgoPipe } from './shared/pipes/time-ago.pipe';
import { MessageDayPipe } from './shared/pipes/message-day.pipe';
import { ChatbotFacade } from './facades/chatbot.facade';
import { ChatbotMapper } from './data/mappers/chatbot.mapper';
import { ChatbotApiService } from './infrastructure/api/chatbot.api.service';
import { ChatbotUserContextAdapter } from './infrastructure/adapters/chatbot-user-context.adapter';
import { ConversationHistoryStorageAdapter } from './infrastructure/adapters/conversation-history-storage.adapter';
import { CHATBOT_CHAT_API_URL, CHATBOT_CONVERSATION_API_URL } from './infrastructure/tokens/chatbot-api.tokens';
import {
  getTalkToYourDataApiUrl,
  TALK_TO_YOUR_DATA_CHAT_API_PATH,
  TALK_TO_YOUR_DATA_CONVERSATION_API_PATH,
} from './constants/chatbot.constants';
import { conversationFeatureKey } from './state/conversation/conversation.feature-key';
import { conversationReducer } from './state/conversation/conversation.reducer';

@NgModule({
  declarations: [
    ChatbotPageContainerComponent,
    ChatbotShellComponent,
    SidebarComponent,
    BrandGroupComponent,
    NewChatButtonComponent,
    QuickQuestionListComponent,
    ConversationHistoryComponent,
    SavedConversationsComponent,
    ConversationListItemComponent,
    UserProfileComponent,
    WelcomePanelComponent,
    SuggestionCardComponent,
    ConversationPanelComponent,
    MessageListComponent,
    MessageItemComponent,
    MessageRendererComponent,
    MessageInputComponent,
    CollapsibleSectionComponent,
    ChatbotMarkdownPipe,
    TimeAgoPipe,
    MessageDayPipe,
  ],
  imports: [
    CommonModule,
    TalkToYourDataRoutingModule,
    ArkikWebComponentsModule,
    StoreModule.forFeature(conversationFeatureKey, conversationReducer),
    TranslateModule,
    OverlayModule,
    NzModalModule,
  ],
  providers: [
    ChatbotFacade,
    ChatbotApiService,
    ChatbotMapper,
    ChatbotUserContextAdapter,
    ConversationHistoryStorageAdapter,
    {
      provide: CHATBOT_CHAT_API_URL,
      useFactory: (config: CoreAuthConfig) =>
        getTalkToYourDataApiUrl(config.api.apimBaseUrl, TALK_TO_YOUR_DATA_CHAT_API_PATH),
      deps: [CORE_AUTH_CONFIG],
    },
    {
      provide: CHATBOT_CONVERSATION_API_URL,
      useFactory: (config: CoreAuthConfig) =>
        getTalkToYourDataApiUrl(config.api.apimBaseUrl, TALK_TO_YOUR_DATA_CONVERSATION_API_PATH),
      deps: [CORE_AUTH_CONFIG],
    },
  ],
})
export class TalkToYourDataModule {}
